import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '@library-shared/base/base.component';
import zxcvbn from 'zxcvbn';

@Component({
    selector: 'app-password-strength-meter',
    templateUrl: './password-strength-meter.component.html',
    styleUrls: ['./password-strength-meter.component.scss'],
    standalone: false
})
export class PasswordStrengthMeterComponent extends BaseComponent implements OnInit {
    _password: string;
    @Input()
    set passwordToCheck(value: string) {
        this._password = value;
        this.updatePasswordStrength();
    }
    get passwordToCheck(): string {
        return this._password;
    }

    @Input() barLabel = 'Password Strength';

    @Output() scoreChanged = new EventEmitter<PasswordStrengthMeterResponse>();

    barColors: string[];

    private colors = ['#F00', '#F90', '#FF0', '#9F0', '#0F0'];

    passwordStrength = 0;

    constructor() {
        super();
    }

    ngOnInit() {
        this.updateBarColors('');
    }

    updateBarColors(color): void {
        this.barColors = [];

        for (let i = 0; i < 5; i++) {
            this.barColors.push(i <= this.passwordStrength ? color : '');
        }
    }

    updatePasswordStrength(): void {
        const results = zxcvbn(this.passwordToCheck);
        this.passwordStrength = results.score;
        this.scoreChanged.emit({ passwordScore: this.passwordStrength, isStrong: this.passwordStrength >= 3 });

        const color = this.colors[this.passwordStrength];
        this.updateBarColors(color);
    }
}

export class PasswordStrengthMeterResponse {
    passwordScore: number;
    isStrong = false;
}
